import {Actions, createEffect, ofType} from "@ngrx/effects";
import {inject} from "@angular/core";
import {catchError, exhaustMap, map, of} from "rxjs";
import {ErrorHandlingUtil} from "../../utils/error-handling-util";
import {NewsService} from "../../services/news/news.service";
import {NewsActions} from "../shared.actions";

export const loadNews = createEffect(
    (actions$ = inject(Actions), newsService = inject(NewsService)) => {
        return actions$.pipe(
            ofType(NewsActions.loadNews),
            exhaustMap(({context, query}) => {
                return newsService.fetchNews(query).pipe(
                    map(searchResult => NewsActions.loadNewsSuccess({context, searchResult})),
                    catchError(err => of(NewsActions.loadNewsError({context, error: ErrorHandlingUtil.getErrorMessage(err)})))
                );
            })
        );
    },
    {functional: true}
);

export const assessNews = createEffect(
    (actions$ = inject(Actions), newsService = inject(NewsService)) => {
        return actions$.pipe(
            ofType(NewsActions.assessNews),
            exhaustMap(({context, searchResult}) => {
                return newsService.assessNews(searchResult).pipe(
                    map(assessment => NewsActions.assessNewsSuccess({context, assessment})),
                    catchError(err => of(NewsActions.assessNewsError({context, error: ErrorHandlingUtil.getErrorMessage(err)})))
                );
            })
        );
    },
    {functional: true}
);

export const assessNewsAfterLoad = createEffect(
    (actions$ = inject(Actions)) => {
        return actions$.pipe(
            ofType(NewsActions.loadNewsSuccess),
            map(({context, searchResult}) => NewsActions.assessNews({context, searchResult}))
        );
    },
    {functional: true}
);

